import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { clsx } from 'clsx';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
}

export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  className,
}) => {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    }
    
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    // The outer wrapper carries `.be-embedded-app` so the scoped CSS bundled
    // by the map embed (every Tailwind selector is prefixed with this class)
    // still applies to portal content that renders at document.body. The
    // class is benign outside the embed — `map.css` isn't loaded there.
    <div className="be-embedded-app">
      <div
        className="be-modal-backdrop fixed inset-0 z-[9999] bg-black/50 flex items-center justify-center p-0 sm:p-4"
      >
        <div
          className={clsx('be-modal relative bg-white rounded-lg shadow-xl max-h-[100vh] flex flex-col', className)}
          onClick={(e) => e.stopPropagation()}
        >
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-2xl z-10"
            aria-label="Close modal"
          >
            ×
          </button>
          <div className="flex-1 min-h-0 h-full">
            {children}
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};
